
export function checkWord(solution, attempt) {
    const status = Array(solution.length).fill("absent");
    const solArray = solution.split("");

    // Première passe : exact
    attempt.split("").forEach((l, i) => {
      if (l === solArray[i]) {
        status[i] = "correct";
        solArray[i] = null;
      }
    });

    // Deuxième passe : présent
    attempt.split("").forEach((l, i) => {
      if (status[i] === "correct") return;
      if (status[i] === "present") return;
      const pos = solArray.indexOf(l);
      if (pos !== -1) {
        status[i] = "present";
        solArray[pos] = null;
      }
    });

    return status;
}

// clear data when game is over
export function clearStorage() {
  localStorage.removeItem('motus_grid');
  localStorage.removeItem('motus_statuses');
  localStorage.removeItem('motus_confirmed');
  localStorage.removeItem('motus_word');
  localStorage.removeItem('motus_validate');
  localStorage.removeItem('motus_keyboard');
}